import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import vistamronImg from '@/assets/images/products/vistamrob.png';

// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaMROB = () => {
  return (
    <div className="2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista MR-OB"
        subTitle="(Ready To Use Powder For Lubrication Of Concrete Pump & Pumpline)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct
          title="Description"
          imageUrl={vistamronImg}
          content="Vista MR-OB is a low viscous mineral oil based shutter release agent. Ready for direct application and use."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Uses">
          <Paragraph content="Vista MR-OB can be used on shutterings to obtain clean and
                                smooth concrete surface and it's use facilitates makes it easy
                                and fast removal and cleaning of:" />
          <CustomLists
            items={[
              [
                "Steel formwork",
                "Plastic formwork",
              ],
              [
                "Timber formwork",
                "Aluminium formwork",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Minimum cleaning of shutters before reuse.",
                "Extended life of formwork.",
                "No dirt sticks on surface after it is dried.",
                "Clean, fast and easy stripping of formwork.",
              ],
              [
                "Improved finish stain and air free faced concrete.",
                "Reduced concrete contamination.",
                "High coverage.",
                "Does not corrode steel",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Aspect", "Light Brown Liquid"],
                ["Specific Gravity", "0.83 kg/l at 25°C"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Packing">
          <Paragraph content="Vista MR-OB is supplied in 200 kg HDPE Drum" />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaMROB;
